import { CATALOG } from "@/data/vipSimulatorCatalog";
import { itemName } from "@/i18n/items";

function norm(s) {
    return String(s || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ") // "5.56" e "5 56" ficam iguais
        .trim();
}

/** Nomes genéricos que dariam falsos positivos ("madeira" em "parede de madeira", etc.). */
const SKIP = new Set(["madeira", "pedra", "pano", "wood", "stone", "cloth", "scrap", "sucata", "metal", "lona", "corda", "rope"]);

let INDEX = null;
function buildIndex() {
    const rows = [];
    const seen = new Set();
    for (const e of CATALOG) {
        for (const raw of [e.name, itemName(e.name, "en")]) {
            const n = norm(raw);
            if (n.length < 4 || SKIP.has(n) || seen.has(n)) continue;
            seen.add(n);
            rows.push({ n, entry: e, re: new RegExp(`(^|[^a-z0-9])${n}(s|es)?(?=$|[^a-z0-9])`) });
        }
    }
    // Nomes mais longos primeiro: "rifle de assalto de gelo" antes de "rifle de assalto".
    return rows.sort((a, b) => b.n.length - a.n.length);
}

/**
 * Itens do catálogo mencionados num texto (PT ou EN), sem repetidos, por ordem de aparição.
 * @returns {{ id: string, name: string, icon: string, iconCandidates: string[] }[]}
 */
export function detectItems(text, max = 8) {
    if (!INDEX) INDEX = buildIndex();
    let hay = ` ${norm(text)} `;
    const found = [];
    const ids = new Set();
    for (const row of INDEX) {
        const m = row.re.exec(hay);
        if (!m) continue;
        // Remove o trecho para "rifle de assalto" não voltar a contar dentro de um nome maior.
        hay = hay.slice(0, m.index) + " ".repeat(m[0].length) + hay.slice(m.index + m[0].length);
        if (ids.has(row.entry.id)) continue;
        ids.add(row.entry.id);
        found.push({ pos: m.index, item: row.entry });
    }
    return found
        .sort((a, b) => a.pos - b.pos)
        .slice(0, max)
        .map(({ item }) => ({ id: item.id, name: item.name, icon: item.icon, iconCandidates: item.iconCandidates }));
}
